import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DeferredCustomCSS.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EmailReveal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ImageGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/app/src/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StrapiImageClient"] */ "/app/src/components/StrapiImageClient.tsx");
